import React from "react";

const PostSecondary = () => {
  return (
    <>
      <div className="LegalsPage">
        <div className="terms">
          <h3>Post Secondary</h3>
        </div>
      </div>
    </>
  );
};

export default PostSecondary;
